import { required, maxLength, email, requiredIf, helpers  } from 'vuelidate/lib/validators';
import store from '@/store/index';
import { CREATE_SHIPMENT_PREFIX, GETTERS } from '../store/constants';

const customMailValidator = (value) => !helpers.req(value) || (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value))

export default {
    accountNumber: {},
    vatNumber: {},
    name: {
        required: requiredIf((vm) => {
            return store.getters[
                CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.HAS_SHIPPINGOPTIONS
            ] && vm;
        }),
        maxLength: maxLength(50)
    },
    street1: {
        required: requiredIf((vm) => {
            return store.getters[
                CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.HAS_SHIPPINGOPTIONS
            ] && vm;
        }),
        maxLength: maxLength(50)
    },
    street2: {
        maxLength: maxLength(50)
    },
    street3: {
        maxLength: maxLength(50)
    },
    postalCode: {
        maxLength: maxLength(10)
    },
    city: {
        required : requiredIf((vm) => {
            return vm != null
        }),
        maxLength: maxLength(50)
    },
    countryCode: {
        required: requiredIf((vm) => {
            return vm != null
        }),
    },
    stateCode: {
        required: requiredIf((vm) => {
            if ( vm && (vm.countryCode === 'US' || vm.countryCode === 'CA')) {
                return true;
            }
            return false;
        })
    },
    contactPerson: {
        name: {
            maxLength: maxLength(50)
        },
        phone: {
            maxLength: maxLength(50)
        },
        mails: {
            $each: {
                maxLength: maxLength(50),
                email: customMailValidator
            }
        }
    }
};
